import { useState } from "react";
import GroupButtons from "../../../../../../../Components/GroupButtons/GroupButtons";
import IconButtons from "../../Components/IconButtons/IconButtons";

import { FaRegClock, FaRegPauseCircle, FaLock, FaLockOpen, FaPlay, FaBomb  } from "react-icons/fa";
import { IoWarningOutline } from "react-icons/io5";
import { FaB, FaExplosion } from "react-icons/fa6";
import { TbSwords } from "react-icons/tb";
import { MdRestartAlt } from "react-icons/md";
import { GoNoEntry } from "react-icons/go";
import { VscDebugStart } from "react-icons/vsc";
import { AddToastNotification } from "../../../../../../../Services/ToastNotification/ToastNotificationManager";
import ServerRequests from "../../../../../../../Services/Api/ServersRequests.ts";

const RoundEvents = ({serverId}) => {
    const serverRequests = new ServerRequests();
    const [selected, setSelected] = useState(0);


    const executeCommand = (command) => {
        serverRequests.ExecuteCommand(serverId, command, () => {
            AddToastNotification("Polecenie wysłane do wykonania!", 1);
        })
    }

    return (
        <>
            <GroupButtons                     
                buttons={[
                        { text: "STATES & EVENTS" }, 
                        { text: "TOKEN SYSTEM" }, 
                    ]}
                selected={selected}
                setSelected={setSelected}
            />
            { selected == 0 &&
                <div className="mt-8">
                    <p className="text-center mb-6">Round-affecting commands and configurations.</p>
                    <div className="flex">
                        <IconButtons 
                            className={"w-[50%]"}
                            title={"Alpha Warhead"}
                            buttons={[
                                { onClick: () => executeCommand("/server_event detonation_start"), icon: <FaRegClock color="rgb(255, 224, 102)" size={"50px"}/>, under: <>Start</> },
                                { onClick: () => executeCommand("/server_event detonation_cancel"), icon: <FaRegPauseCircle color="rgb(153, 204, 255)" size={"50px"}/>, under: <>Stop</>  },
                                { onClick: () => executeCommand("/server_event detonation_instant"), icon: <FaExplosion color="rgb(255, 153, 0)" size={"50px"}/>, under: <>Boom</> },
                            ]}
                        />
                        <IconButtons 
                            className={"w-[50%]"}
                            title={"Decontamination"}
                            buttons={[
                                { onClick: () => executeCommand("/decontamination enable"), icon: <VscDebugStart color="rgb(67, 241, 95)" size={"50px"}/>, under: <>Enable</> },
                                { onClick: () => executeCommand("/decontamination disable"), icon: <GoNoEntry color="rgb(255, 127, 127)" size={"50px"}/>, under: <>Disable</>  },
                                { onClick: () => executeCommand("/decontamination force"), icon: <IoWarningOutline color="rgb(67, 241, 95)" size={"50px"}/>, under: <>Force</> },
                            ]}
                        />
                    </div>
                    <div className="flex mt-16">
                        <IconButtons 
                            className={"w-[50%]"}
                            title={"Round & Lobby"}
                            buttons={[
                                { onClick: () => executeCommand("/forcestart"), icon: <FaPlay color="rgb(67, 241, 95)" size={"50px"}/>, under: <>Play</> },
                                { onClick: () => executeCommand("/roundrestart"), icon: <MdRestartAlt color="rgb(153, 204, 255)" size={"50px"}/>, under: <>Restart</>  },
                            ]}
                        />
                        {/* <IconButtons 
                            className={"w-[50%]"}
                            title={"Gameplay"}
                            buttons={[
                                { icon: <TbSwords color="rgb(67, 241, 95)" size={"50px"}/>, under: <><p>FF</p></> },
                                { icon: <FaBomb color="rgb(255, 127, 127)" size={"50px"}/>, under: <><p>Spawn</p> <p>Protection</p></>  },
                            ]}
                        /> */}
                    </div>
                </div>
            }
            { selected == 1 &&
                <div>
                    
                </div>
            }
        </>
    )
}

export default RoundEvents;